





























import { defineComponent, ref } from "@vue/composition-api";
import { PersonalInformation } from "@scrile/api-provider/dist/api/PersonalInformationProvider";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import { FormValues } from "@/types";
import BaseCheckbox from "@/components/BaseCheckbox";
import BaseForm from "@/components/BaseForm";
import { personalInfoFields } from "../config";

export default defineComponent({
  name: "PersonalInfoForm",
  components: { BaseForm, BaseCheckbox },
  setup(_, { emit }) {
    const { authUserStrict } = useAuthUser();
    const personalInformation = ref<PersonalInformation | null>(null);
    const isSensitiveAgreement = ref(false);
    const formValid = ref(false);

    const values = ref<FormValues>({
      firstName: "",
      lastName: "",
      phone: "",
      sensitiveContent: isSensitiveAgreement.value,
    });

    const getData = async () => {
      personalInformation.value = await providers.PersonalInformationProvider.find({ id: authUserStrict.value.id });
      values.value = {
        firstName: personalInformation.value.firstName,
        lastName: personalInformation.value.lastName,
        phone: personalInformation.value.phone,
        sensitiveContent: false,
      };
    };

    const submitPersonalInfo = async () => {
      const data = {
        userId: authUserStrict.value.id,
        firstName: values.value.firstName,
        lastName: values.value.lastName,
        phone: values.value.phone,
      };
      personalInformation.value = await providers.PersonalInformationProvider.update({ data });
      values.value = {
        ...values.value,
        firstName: personalInformation.value.firstName,
        lastName: personalInformation.value.lastName,
        phone: personalInformation.value.phone,
      };
    };

    const checkValid = () => {
      const isCheckboxValid = !!values.value.sensitiveContent;
      emit("setValid", formValid.value && isCheckboxValid);
    };

    const handleValidation = (isValid: boolean) => {
      formValid.value = isValid;
      checkValid();
    };

    const inputSensitive = (v: boolean) => {
      values.value.sensitiveContent = v;
      checkValid();
    };

    const created = async () => {
      emit("setCb", () => submitPersonalInfo());
      try {
        emit("setLoading", true);
        await getData();
      } finally {
        emit("setLoading", false);
      }
    };

    created();

    return {
      values,
      personalInfoFields,
      handleValidation,
      inputSensitive,
    };
  },
});
